import { gql, MutationHookOptions, useMutation } from "@apollo/client";

export interface UnmatchAssetMutationVariables {
  id: string;
  unmatchReasons: string[];
}

export interface UnmatchAssetMutationResult {
  unmatchAsset: {
    success: boolean;
  };
}

export const UNMATCH_ASSET_MUTATION = gql`
  mutation unmatchAsset($id: ID!, $unmatchReasons: [String!]!) {
    unmatchAsset(assetId: $id, unmatchReasons: $unmatchReasons) {
      success
    }
  }
`;

export const useUnmatchAssetMutation = (
  options?: MutationHookOptions<
    UnmatchAssetMutationResult,
    UnmatchAssetMutationVariables
  >
) =>
  useMutation<UnmatchAssetMutationResult, UnmatchAssetMutationVariables>(
    UNMATCH_ASSET_MUTATION,
    options
  );
